export default __webpack_public_path__ + "static/media/cact_covid_safety_plan_for_clubs.8b6f6c3c.pdf";